import { destroyComponent } from './destroy.component';

export const destroyModule = angular
  .module('destroy', [])
  .component('destroy', destroyComponent );


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/destroy/destroy.js
 **/